import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { MultiStyleType } from '@chakra-ui/styled-system'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { textStyles } from '~/themes/textStyles/defaultTextStyles'
import { getName } from '~/utils/objectUtils'

const { PrimaryButton: PrimaryButtonColors } = themeColorSectionKeys.shared

const {
  Background: {
    SecondaryNav: { Hover: SecondaryNavHoverColor },
  },
} = themeColorSectionKeys.defaults

export const enum ParkTargetVariants {
  Default = 'default',
  Available = 'available',
  Unavailable = 'unavailable',
}

const parkTargetParts = [
  'container',
  'presenceBadge',
  'text',
  'button',
] as const

const helpers = createMultiStyleConfigHelpers(parkTargetParts)

export const ParkTargetStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      height: '3.875rem',
      width: 'full',
      paddingY: '0.75rem',
      paddingX: '1.25rem',
      gap: '0.75rem',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderRadius: '0.5rem',
      backgroundColor: 'transparent',
      _hover: {
        backgroundColor: SecondaryNavHoverColor,
      },
    },
    text: {
      ...textStyles[textStyleKeys.Body1],
    },
    button: {
      height: '2.375rem',
      paddingY: '0.625rem',
      paddingX: '1.125rem',
      backgroundColor: PrimaryButtonColors.Background.Default,
      borderRadius: '100px',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      display: 'none',
      '& > p': {
        color: PrimaryButtonColors.FontColor.Default,
        ...textStyles[textStyleKeys.Body2_Semibold],
      },
    },
  },
  variants: {
    [ParkTargetVariants.Default]: {
      container: {
        _hover: {
          '& div.refer-call-button': {
            display: 'flex',
          },
        },
      },
    },
    [ParkTargetVariants.Available]: {
      container: {
        _hover: {
          '& div.refer-call-button': {
            display: 'flex',
          },
        },
      },
    },
    [ParkTargetVariants.Unavailable]: {},
  },
  defaultProps: {},
})

export const useParkTargetStyle = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(
    getName({ ParkTargetStyle }),
    props,
  ) as MultiStyleType<typeof parkTargetParts>
}
